/**
 * Copyright (c) 2022, Kemp Technologies
 */
export class IsRegExp {
  static validate(value: any, expression: string) {
    if (typeof value !== "string") {
      return false;
    }
    let expr: any;
    if (expression.indexOf("/") === 0) {
      const exprArr = expression.slice(1).split("/");
      expr = [exprArr.slice(0, -1).join("/"), ...exprArr.slice(-1)];
    } else {
      expr = [expression, ""];
    }
    // @ts-expect-error
    return !!value.match(new RegExp(...expr));
  }
}
